import Table from "../../Components/Table";
import StatusHandler from "../../Components/Table/StatusHandler";
import useFetchData from "../../Hooks/useFetchData";
import useTableControls from "../../Hooks/useTableControls";
import { getFeedbacks } from "../../Services/Feedback";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import PageHeader from "../../Components/PageHeader";

export default function Feedbacks() {
  // const sampleData = [
  //   {
  //     sn: "1",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  //   {
  //     sn: "2",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  //   {
  //     sn: "3",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  //   {
  //     sn: "4",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  // ];

  const {
    perPage,
    setPerPage,
    status,
    setStatus,
    search_string,
    setSearchString,
    from,
    setFrom,
    to,
    setTo,
  } = useTableControls();

  const {
    // INTERNAL EXPORTS
    page,
    setPage,
    // REACT QUERY EXPORTS
    isFetching,
    isLoading,
    data,
    refetch,
  } = useFetchData("feedback_logs", getFeedbacks, [
    perPage,
    search_string,
    from,
    to,
  ]);
  // console.log("feedback_logs Data: ", data?.data);

  return (
    <div className="app-content content">
      <div className="content-wrapper">
        <div className="content-body">
          {/* Basic form layout section start */}
          <section id="configuration">
            <div className="row">
              <div className="col-12">
                <div className="user-details-wrapper">
                  <PageHeader
                    title="Feedbacks"
                    subtitle="Review user ratings, driver comments, and service quality reports"
                  />
                  <Table
                    key={"feedbacks-table"}
                    tableTitles={[
                      "S.No.",
                      "Full Name",
                      "User Type",
                      "Date Submitted",
                      "Subject",
                      "Action",
                    ]}
                    dateFilter
                    showEntries
                    // sortBy
                    isLoading={isLoading}
                    isFetching={isFetching}
                    data={data?.data?.data?.docs}
                    totalPages={Math.ceil(data?.data?.data?.totalPages || 0)}
                    totalDocs={data?.data?.data?.totalDocs}
                    page={page}

                    setPage={setPage}
                    setSearchString={setSearchString}
                    status={status}
                    setStatus={setStatus}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    from={from}
                    setFrom={setFrom}
                    to={to}
                    setTo={setTo}
                  >
                    {data?.data?.data?.docs?.map((item, index) => (
                        <tr key={item?._id || index}>
                          <td>{getSerialNumber(data?.data?.data, index)}</td>
                          <td>{item?.user?.firstName}</td>
                           <td className="text-capitalize">{item?.user?.role}</td>
                          <td>
                            {item?.createdAt &&
                              format_date(item?.createdAt, "MM/DD/YYYY")}
                          </td>
                           <td>{item?.subject}</td>
                          {/* <td>{item?.email}</td> */}
                          <td>
                            <StatusHandler
                              key={`${item?._id}-status`}
                              view
                              item={item}
                              redirectUrl={`/feedbacks/feedback-details/${item?._id}`}
                            />
                          </td>
                        </tr>
                      ))}
                  </Table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
            <style>{`
                .fw-800 { font-weight: 800; }
                .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                
                @media (max-width: 576px) {
                    .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                    .user-details-wrapper { padding: 0.5rem; }
                }
            `}</style>
    </div>
  );
}
